import { useSelectedOnBehalfOfUserId } from '../analyticsSettings/selectors';
import { useCanAccessCampaignsInsights, useCanCreateCampaigns } from '../campaignRights';

export const useIsCampaignsEntryPointVisible = (): boolean => {
  const canAccessCampaignInsights = useCanAccessCampaignsInsights();
  const canCreateCampaigns = useCanCreateCampaigns();
  const hasCampaignAnalyticsAccess = canAccessCampaignInsights || canCreateCampaigns;
  const selectedOnBehalfOfUserId = useSelectedOnBehalfOfUserId();
  const isLeaderSelectedOnBehalfOfViewer = !!selectedOnBehalfOfUserId;

  return hasCampaignAnalyticsAccess && isLeaderSelectedOnBehalfOfViewer === false;
};
